import { createContext } from 'react';

export const TypographyContext = createContext();